import { ChangeLanguageService } from "./services/changeLanguage.service";

class LogoutController {
	/*@ngInject*/
	constructor(
		private $location: ng.ILocationService,
		private language: any,
		private changeLanguageService: ChangeLanguageService,
	) {
	}
	login() {
		this.$location.path("/authorize");
	}
}

export const LogoutComponent = {
	templateUrl: "/static/dist/app/login/logout.component.html",
	controllerAs: "$ctrl",
	controller: LogoutController
}